export default __webpack_public_path__ + "7aded9c.png";